/**
 * 全球指数页面
 */
import React from "react"
import "./index.less"
import { StockHeader } from "../../shared/stock_header"
import { quotedata } from "../../shared/quotedata"
import { StockInfoTabs } from "../../shared/stock_info_tabs"
import { ChartTab } from "../../shared/chart_tab"
import { store } from "./store"
import { OpenInApp } from "../../shared/open_in_app"
import { GoTop } from "../../shared/go_top"
import { CommonFooter } from "../../shared/common_footer"
import { StockFixedFooter } from "../../shared/stock_fixed_footer"
import { AdvertiseTop } from "../../shared/advertise_top"
import { GlobalBasicInfo } from "./basic_info"
import { getPageType, getStockSubType, PageType, StockSubType } from "../../shared/pagetype"
import { Observer } from "mobx-react-lite"

export function Page_GlobalIndex(props: { quotedata: quotedata }) {
  let pagetype = getPageType()
  let stocksubtype = getStockSubType()
  let infoTabs = ["股吧", "成分股"]
  if (stocksubtype == StockSubType.纳斯达克指数) {
    infoTabs = ["股吧"]
  }

  return (
    <>
      <AdvertiseTop />
      <div className="stock-detail">
        <WrapStockHeader quotedata={props.quotedata} pagetype={pagetype}/>
        <GlobalBasicInfo />
        <WrapCharts quotedata={props.quotedata} pagetype={pagetype} stocksubtype={stocksubtype} />
        <StockInfoTabs showTabs={infoTabs} quotedata={props.quotedata} pagetype={pagetype} />
      </div>
      <OpenInApp quotedata={props.quotedata} type={"page"} />
      <GoTop />
      <CommonFooter quotedata={props.quotedata} hide_fix_bottom={false} />
      <StockFixedFooter quotedata={props.quotedata} pagetype={pagetype} />
    </>
  )
}

function WrapStockHeader(props: { quotedata: quotedata ,pagetype: PageType}) {
  return <Observer>{() => <StockHeader quotedata={props.quotedata} detail_data={store.StockDetail} pagetype={props.pagetype}/>}</Observer>
}

function WrapCharts(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <>{store.StockDetail && <ChartTab quotedata={props.quotedata} pagetype={props.pagetype}  stocksubtype={props.stocksubtype} />}</>}</Observer>
}
